export default "__VITE_ASSET__CkKnXiLV__"